import SectionHeading from "./SectionHeading";
import { hotWords } from "@/mocks/trending";

interface TrendsProps {
  onPick: (word: string) => void;
}

const tone = (heat: number) => {
  if (heat >= 90) return "bg-primary-500 text-background-50 hover:bg-primary-600";
  if (heat >= 75) return "bg-accent-100 text-accent-800 hover:bg-accent-200";
  if (heat >= 62) return "bg-primary-100 text-primary-800 hover:bg-primary-200";
  return "bg-secondary-100 text-secondary-800 hover:bg-secondary-200";
};

const size = (heat: number) => (heat >= 90 ? "text-base px-5 py-2.5" : heat >= 75 ? "text-sm px-4 py-2" : "text-xs px-3 py-1.5");

export default function Trends({ onPick }: TrendsProps) {
  return (
    <section id="trends" className="scroll-mt-24 border-y border-background-200/70 bg-accent-50/50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeading
            eyebrow="Hot Keywords"
            title="热搜词，看看大家都在搜什么"
            desc="根据全网讨论热度实时汇总的热词墙，点击即可快速检索对应瓜料。"
          />
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {hotWords.map((w) => (
            <button
              key={w.word}
              onClick={() => onPick(w.word)}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full font-semibold transition-colors ${tone(w.heat)} ${size(w.heat)}`}
            >
              #{w.word}
              <i className="ri-arrow-up-line text-[11px] opacity-80"></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}